module.exports = __webpack_public_path__ + "img/arrow_outward.a53af967.svg";